module.exports = __webpack_public_path__ + "img/sense.886afa79.jpg";